/**
 * Playready Key System.
 *
 *
 * @beta
 */
export const PLAYREADY_KEY_SYSTEM = 'com.microsoft.playready'
